import React, { useState } from "react";
import "./LegalPages.css";

/* Custom Send Icon */
const SendAlertIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m22 2-7 20-4-9 9-4Z" />
    <path d="M22 2 11 13" />
  </svg>
);

function ReportIssue() {
  const [issueData, setIssueData] = useState({
    name: "",
    category: "General Inquiry",
    reason: ""
  });

  // Requested destination number
  const adminWhatsAppNumber = "917884561230";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIssueData((prev) => ({ ...prev, [name]: value }));
  };

  const handleIssueSubmit = (e) => {
    e.preventDefault();

    if (!issueData.name || !issueData.reason) {
      alert("Please provide your name and detail the specific issue.");
      return;
    }

    // Package the payload exactly for WhatsApp dispatch
    const alertMessage = `⚠️ *TRUST ISSUE REPORT* ⚠️\n\n👤 *Reporter Name:* ${issueData.name}\n🏷️ *Category:* ${issueData.category}\n\n📝 *Issue Description:*\n${issueData.reason}\n\n_Dispatched directly from the Anuk Trust Support Portal._`;

    const encodedAlert = encodeURIComponent(alertMessage);
    const whatsappRedirectUrl = `https://wa.me/${adminWhatsAppNumber}?text=${encodedAlert}`;

    // Open WhatsApp integration immediately
    window.open(whatsappRedirectUrl, "_blank");

    // Reset local state
    setIssueData({ name: "", category: "General Inquiry", reason: "" });
  };

  return (
    <div className="legal-page-wrapper">
      {/* Hero Banner */}
      <section className="legal-hero" style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }} >
        <div className="hero-overlay-mask"></div>
        <div className="hero-content-box">
          <h1 className="hero-main-title" style={{
    textAlign: "center"
  }}>Report an Issue</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Report an Issue</span>
          </div>
        </div>
      </section>

      {/* Interactive Form Section */}
      <section className="legal-main-section">
        <div className="legal-container">
          <div className="issue-form-card">
            <div className="form-head-block">
              <span className="meta-badge">COMMUNICATION DESK</span>
              <h2>Submit an Operational Alert</h2>
              <p className="lead-text">
                Encountered a portal anomaly, payment latency, or wish to report a compliance matter? Detail your observation below to trigger an immediate direct WhatsApp alert to our managing administration.
              </p>
            </div>

            <form onSubmit={handleIssueSubmit} className="issue-submission-form">
              {/* Full Name Input */}
              <div className="field-group">
                <label htmlFor="name">Your Complete Name <span className="required">*</span></label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter your complete legal name"
                  value={issueData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Categorical Dropdown */}
              <div className="field-group">
                <label htmlFor="category">Issue Classification</label>
                <select
                  id="category"
                  name="category"
                  value={issueData.category}
                  onChange={handleInputChange}
                >
                  <option value="General Inquiry">General Technical Inquiry</option>
                  <option value="Donation Receipt Latency">Donation / Receipt Latency</option>
                  <option value="Portal Navigation / Bug">Portal Navigation Anomaly / Bug</option>
                  <option value="Volunteer Coordination">Volunteer Coordination Misalignment</option>
                  <option value="Compliance / Ethical Concern">Compliance / Ethical Concern</option>
                </select>
              </div>

              {/* Detailed Reason Textarea */}
              <div className="field-group">
                <label htmlFor="reason">Issue Description &amp; Context <span className="required">*</span></label>
                <textarea
                  id="reason"
                  name="reason"
                  rows="6"
                  placeholder="Clearly describe the sequence of events, specific transaction numbers, or operational discrepancies..."
                  value={issueData.reason}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>

              {/* Submit Dispatch Trigger */}
              <button type="submit" className="btn-dispatch-alert">
                <span>Dispatch Alert via WhatsApp</span>
                <SendAlertIcon />
              </button>

             
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ReportIssue;